// Internal dependencies.
import { ListItemColumnProps, WidthType } from './ListItemColumn.types';

// Test IDs
export const TESTID_LISTITEMCOLUMN = 'listitemcolumn';

// Defaults
export const DEFAULT_LISTITEMCOLUMN_WIDTHTYPE = WidthType.Auto;

// Sample consts
export const SAMPLE_LISTITEMCOLUMN_PROPS: ListItemColumnProps = {
  widthType: DEFAULT_LISTITEMCOLUMN_WIDTHTYPE,
};
